<template>
  <div>
    <el-row>
      <span >
        <el-button type="text" @click="add">Add New <i class="fas fa-plus-square"/></el-button>
      </span>
    </el-row>
    <el-row>
      <el-col :md="12">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="description"
            label="Description"/>
          <el-table-column
            prop="amount"
            label="Amount"/>
          <el-table-column
            prop="status"
            label="Status">
            <template slot-scope="scope">
              {{ scope.row.status === 1 ? 'Active' : 'In active' }}
            </template>
          </el-table-column>
          <el-table-column label="Operation" align="center">
            <template slot-scope="scope">
              <el-button type="warning" size="small" @click="edit(scope.row)"><i class="fas fa-edit"/></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;">
          <el-pagination :page-size="meta.per_page" :pager-count="7" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
        </div>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="showform" :title="title" width="30%" center @close="closeModal">
      <el-form ref="form" :model="form" label-position="top">
        <el-form-item label="Description" prop="description">
          <el-input
            v-model="form.description"
            :rows="2"
            type="textarea"
            placeholder="Please input ..... example (Less 5 thousand)"/>
        </el-form-item>
        <el-form-item label="Amount" prop="amount">
          <el-input
            v-model="form.amount"
            placeholder="Please input"/>
        </el-form-item>
        <el-form-item label="Status" prop="status">
          <el-select v-model="form.status" placeholder="Select...">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModal">Cancel</el-button>
        <el-button type="primary" @click="save()">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Others } from '@/api/payroll/others'
import { NotifySuccess } from '../../../helper/Helper'
export default {
  name: 'LessPay',
  data() {
    return {
      editable: false,
      loading: false,
      meta: {
        page: 1
      },
      title: 'Add data',
      showform: false,
      tableData: [],
      form: {
        'description': null,
        'amount': 5000,
        'status': 1
      },
      options: [
        {
          value: 1,
          label: 'Active'
        },
        {
          value: 2,
          label: 'In active'
        }
      ],
      formRules: {
        description: [{ required: true, message: 'Description is required', trigger: 'blur' }],
        amount: [{ required: true, message: 'Amount is required', trigger: 'blur' }],
        status: [{ required: true, message: 'Status number is required', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getAll()
  },
  methods: {
    closeModal() {
      this.editable = false
      this.showform = false
      this.title = 'Add data'
      this.form = {
        'description': null,
        'amount': 5000,
        'status': 1
      }
    },
    getAll() {
      this.loading = true
      Others({ page: this.meta.page }, 'get', 'getLessPay').then(res => {
        this.tableData = res.data.lessPay
        this.meta = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    add() {
      this.title = 'Add data'
      this.showform = true
    },
    edit(data) {
      this.editable = true
      this.title = 'Edit data'
      this.showform = true
      this.form = {
        less_id: data.id,
        description: data.description,
        amount: data.amount,
        status: data.status
      }
    },
    save() {
      if (this.editable === false) {
        this.form.less_id = null
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          const action = this.form.less_id ? 'updateLessPayData' : 'storeLessPayData'
          this.loading = true
          Others(this.form, 'post', action).then(res => {
            if (res.data.status === 'success') {
              if (action === 'updateLessPayData') {
                NotifySuccess('Data Successfully Updated!')
              } else {
                NotifySuccess('Data Successfully Added!')
              }
              this.getAll()
              this.closeModal()
            }
          }).catch(error => {
            console.log(error)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
</style>
